import { ReactNode, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { resetPayeeState } from 'lib/slices/payeeSlice';
import { useNavigate } from 'react-router-dom';
import LoadingText from 'components/shared/generic/loader/LoadingText';
import { PAYMENT_MANAGE_PAYEES } from '../../../../../constants/shared/routes';
import useTranslate from 'lib/languages/useTranslate';

interface PayeeCreationWrapperProps {
    children: ReactNode;
    isLoading: boolean;
    isPayeeCreated: boolean;
}

const PayeeCreationWrapper: React.FC<PayeeCreationWrapperProps> = ({
    children,
    isLoading,
    isPayeeCreated,
}) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const translate = useTranslate('addPayee');

    useEffect(() => {
        if (isPayeeCreated) {
            navigate(PAYMENT_MANAGE_PAYEES);
            dispatch(resetPayeeState());
        }
    }, [dispatch, navigate, isPayeeCreated]);

    if (isLoading) {
        return <LoadingText text={translate('loadingCreatePayee')} />;
    }

    if (isPayeeCreated) {
        return null;
    }

    return children;
};

export default PayeeCreationWrapper;
